// extracted by mini-css-extract-plugin
export var avatar = "_ko-3";
export var avatarContainer = "_ko-2";
export var avatarSpacer = "_ko-5";
export var avatarSpacerContainer = "_ko-4";
export var avatarStackContainer = "_ko-1";
export var bubble = "_ko-0";
export var remainderBubble = "_ko-6";